import './footer.scss';

export const Footer = ({ ...rest }) => {
  return <Footer className={'footer'} {...rest} />;
};
